import { render, staticRenderFns } from "./ImportArticle.vue?vue&type=template&id=42ad82c2&scoped=true"
import script from "./ImportArticle.vue?vue&type=script&lang=ts"
export * from "./ImportArticle.vue?vue&type=script&lang=ts"
import style0 from "./ImportArticle.vue?vue&type=style&index=0&id=42ad82c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad82c2",
  null
  
)

export default component.exports